import { reactive } from 'vue';
import { config } from 'vue-gtag';
import util from '@/Utils/util';
import { sendAuthTokenToExtension } from '@/services/extensionAuth';

export const useAuth = () => {
  const status = reactive({
    resultHtml: '',
    loading: false,
  });

  const handleAuthResponse = (res: any) => {
    const { isActive, roles, id, logins, rumLogLevel } = res.data.user;

    if (isActive || roles.includes('customer') || roles.includes('family') || roles.includes('affiliate')) {
      localStorage.setItem('access_token', res.data.token);
      localStorage.setItem('roles', JSON.stringify(roles));
      localStorage.setItem('rum_log_level', rumLogLevel ?? '');
      sendAuthTokenToExtension();

      if (!roles.includes('customer') && !roles.includes('family')) {
        localStorage.setItem('operatorId', id);
      }

      config({ user_id: id });

      let defaultPage = '';

      if (!roles.includes('customer') && !roles.includes('family') && !roles.includes('affiliate') && logins === 1) {
        defaultPage = '/operator/account';
      }

      return { roles, defaultPage };
    } else {
      status.resultHtml = util.getErrorResponse({
        message: 'Your account is not active.',
      });
      return null;
    }
  };

  const gotoDashboard = (roles: string[], defaultPage = '') => {
    if (defaultPage) {
      window.location.href = defaultPage;
    } else if (roles.includes('family') || roles.includes('customer')) {
      window.location.href = '/family';
    } else if (roles.includes('partner')) {
      window.location.href = '/partner';
    } else if (roles.includes('affiliate')) {
      window.location.href = '/affiliate';
    } else {
      window.location.href = '/operator';
    }
  };

  return {
    status,
    handleAuthResponse,
    gotoDashboard,
  };
};
